<div class="slide-notes-element">
  <mat-card-content>
    <st-rich-text-editor [content]="notes.content" (contentEvent)="editText($event)"> </st-rich-text-editor>
  </mat-card-content>
</div>
